import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import CochlearImplantPage from "@/pages/CochlearImplantPage";
import ServicesPage from "@/pages/ServicesPage";
import VideosPage from "@/pages/VideosPage";
import BookAppointmentPage from "@/pages/BookAppointmentPage";
import ContactPage from "@/pages/ContactPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ConditionPage from "@/pages/ConditionPage";
import ProcedurePage from "@/pages/ProcedurePage";
import CSRPage from "@/pages/CSRPage";
import CIProductsPage from "@/pages/CIProductsPage";
import HearingAidsPage from "@/pages/HearingAidsPage";

// Layout
import MainLayout from "@/components/layout/MainLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="cochlear-implant" element={<CochlearImplantPage />} />
            <Route path="cochlear-implant/products" element={<CIProductsPage />} />
            <Route path="hearing-aids" element={<HearingAidsPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="book-appointment" element={<BookAppointmentPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="csr" element={<CSRPage />} />
            <Route path="support-deaf-children" element={<CSRPage />} />
            <Route path="conditions/:slug" element={<ConditionPage />} />
            <Route path="procedures/:slug" element={<ProcedurePage />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
